import { Component, Host, h, Element, Event, EventEmitter, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'me-card-radio',
  styleUrl: 'me-card-radio.scss',
  shadow: false,
})
export class MeCardRadio {

  private static nextRadioID = 1;
  private readonly radioID = MeCardRadio.nextRadioID++;

  @Element() host: HTMLMeCardRadioElement;

  @Event() meCardRadioChange: EventEmitter<HTMLMeCardRadioElement>;

  @Prop({ mutable: true }) isActive = false;

  private card: HTMLMeCardElement;
  private input: HTMLInputElement;

  @Listen('meCardRadioChange', { target: 'window' })
  handleMeCardRadioChange(event: CustomEvent<HTMLMeCardRadioElement>) {
    if (event.detail.parentElement !== this.host.parentElement) {
      return;
    }

    this.isActive = event.detail === this.host;
  }

  connectedCallback() {
    this.card = this.host.querySelector('me-card');
    this.input = this.host.querySelector('input');

    this.isActive = this.input.checked;

    this.input.addEventListener('change', this.meCardRadioChange.emit.bind(this, this.host));
  }

  disconnectedCallback() {
    this.input.removeEventListener('change', this.meCardRadioChange.emit.bind(this, this.host));
  }

  render() {
    this.input.id = `me-card-radio-input-${this.radioID}`;

    this.card.highlighted = this.isActive;

    return (
      <Host class="me-card-radio">
        <label htmlFor={this.input.id}>
          <slot />
        </label>
      </Host>
    );
  }

}
